import {
  alpha,
  Box,
  IconButton,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import { Perfil } from "../../../pages/easyReport/perfilRelatorio/Index";
import { useStyle } from "./styles";
import { DeleteOutlined, EditOutlined } from "@mui/icons-material";

interface CardPerfilProps {
  perfil: Perfil;
  selectedPerfil: Perfil | null;
  handleSelectPerfil: (perfil: Perfil | null) => void;
  handleEditPerfil: (perfil: Perfil | null) => void;
  handleDelete: (
    id: string,
    ßagendamentos: string[],
    relatorios: string[],
  ) => void;
}

export const CardPerfil: React.FC<CardPerfilProps> = ({
  perfil,
  selectedPerfil,
  handleSelectPerfil,
  handleEditPerfil,
  handleDelete,
}) => {
  const theme = useTheme();
  const styles = useStyle(theme, selectedPerfil, perfil);

  return (
    <Box
      sx={styles.container}
      onClick={(): void =>
        handleSelectPerfil(selectedPerfil?.id !== perfil?.id ? perfil : null)
      }
    >
      <Box sx={styles.bar} />
      <Tooltip
        title={
          perfil.isDefault && "Você não pode editar ou deletar um perfil padrão"
        }
      >
        <Box sx={styles.textBox}>
          <Typography sx={styles.titleCard}> {perfil?.titulo}</Typography>
          <Typography sx={styles.descriptionCard}>
            {perfil?.descricao}
          </Typography>
        </Box>
      </Tooltip>
      <IconButton
        size="small"
        onClick={(e) => {
          e.stopPropagation();
          handleEditPerfil(perfil);
        }}
        disabled={perfil.isDefault}
        sx={
          perfil?.isDefault
            ? { color: theme.palette.text.disabled }
            : selectedPerfil?.id == perfil?.id
              ? { color: theme.palette.primary.main }
              : { color: theme.palette.text.primary }
        }
      >
        <EditOutlined />
      </IconButton>
      <IconButton
        size="small"
        color={selectedPerfil?.id == perfil?.id ? "primary" : "secondary"}
        onClick={(e) => {
          e.stopPropagation();
          handleDelete(
            perfil.id,
            perfil.agendamentos ?? [],
            perfil.relatorios ?? [],
          );
        }}
        disabled={perfil.isDefault}
        sx={
          perfil?.isDefault
            ? { color: theme.palette.text.disabled }
            : selectedPerfil?.id == perfil?.id
              ? { color: theme.palette.primary.main }
              : { color: theme.palette.error.main }
        }
      >
        <DeleteOutlined />
      </IconButton>
    </Box>
  );
};
